import React, { Component } from 'react';
import ToolbarItem from './ToolbarItem';
import Draggable from 'react-draggable';
import { connect } from 'react-redux';
import * as toolbarValidations from './ToolbarValidations';
import * as fabricCanvasActions from '../../redux/fabricCanvasActions';
import * as sideBarActions from '../../redux/sideBarActions';
import * as homeActions from '../../redux/homeActions';
import * as canvasZoomActions from '../../redux/canvasZoomActions';
import * as multiWallHandler from '../../redux/actions/multiWallHandler';
import * as Constants from '../../utilities/constants/Constants';
import { bindActionCreators } from 'redux';
import '../Body/DesignComponent/FabricCanvas/FabricCanvas.scss';
import { string } from '../../localization';
import { Icons } from '../../utilities';
import { Popover, Tooltip } from 'reactstrap';
import DraggableModal from '../../UI/DraggableModal/DraggableModal';
import { RotateTool } from './RotateTool/RotateTool';
import { ScaleTool } from './ScaleTool/ScaleTool';
import { TransparencyTool } from './TransparencyTool/TransparencyTool';
import { isImageBasedBackground } from '../../redux/fabricCanvasActionHelpers';
import {
  getActiveCanvas,
  isSignageSuiteProduct
} from '../../utilities/HelperFunctions/HelperFunctions';
import SetSizeTool from './SetSizeTool/SetSizeTool';

class ToolBar extends Component {
  state = {
    rotateModalStatus: false,
    scalarModalStatus: false,
    transparencyModalStatus: false,
    setSizeModalStatus: false,
    alignPopoverStatus: false,
    isAlignTooltipOpen: false,
    alignToolIndex: null,
    initialValue: 0,
    toolBarOptions: [],
    toolState: false,
    isGroupScale: false,
    originX: false
  };

  componentDidMount() {
    this.getToolList();
  }

  componentDidUpdate(prevProps) {
    const { activeObject, language } = this.props;
    if (prevProps.activeObject !== activeObject) {
      this.resetAlignStatus();
    }
    if (prevProps.language !== language) {
      this.getToolList();
    }
  }

  componentWillUnmount() {
    const { rotateModalStatus, scalarModalStatus } = this.state;
    this.setState({
      rotateModalStatus: !rotateModalStatus,
      scalarModalStatus: !scalarModalStatus
    });
  }

  hideOrShowAlignTooltip = (tooltipVisiblity, index) => {
    this.setState({
      isAlignTooltipOpen: tooltipVisiblity,
      alignToolIndex: index
    });
  };

  handleClearAll = () => {
    const { dispatchers } = this.props;
    const dict = {
      header: string.CLEAR_ALL_OBJECTS,
      description: string.CLEAR_ALL_OBJECTS_WARNING_MESSAGE,
      stringColor: Constants.DEFAULT_STRING_COLOR,
      onclick: dispatchers.fabricCanvasActions.canvasReset,
      onCancel: null,
      buttonTitles: { finish: string.OK_KEY, cancel: string.CANCEL_TEXT_KEY }
    };
    dispatchers.fabricCanvasActions.setMessageDialogParams(dict);
  };

  getToolList = () => {
    const { dispatchers } = this.props;
    this.setState({
      toolBarOptions: [
        {
          name: string.RECOLOR_KEY,
          alt: 'recolor-icon',
          onclick: dispatchers.sideBarActions.getRecolorArray,
          validationMethod: toolbarValidations.canAddRecolorTool,
          id: Constants.RECOLOR_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.recolor,
          highlight_path: Icons.recolor_selected,
          disabled_path: Icons.recolor_disabled
        },
        {
          name: string.TILE_KEY,
          alt: 'tile-icon',
          onclick: dispatchers.fabricCanvasActions.tileAction,
          validationMethod: toolbarValidations.canAddTileTool,
          id: Constants.TILE_TOOL,
          state: Constants.DISABLED_STATE,
          icon_path: Icons.tile,
          highlight_path: Icons.tile_selected,
          disabled_path: Icons.tile_disabled
        },
        {
          name: string.UNTILE_KEY,
          alt: 'untile-icon',
          onclick: dispatchers.fabricCanvasActions.unTileScene,
          validationMethod: toolbarValidations.canAddUnTileTool,
          id: Constants.UNTILE_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.untile,
          highlight_path: Icons.untile_selected,
          disabled_path: Icons.untile_disabled
        },
        {
          name: string.TRANSPARENCY_KEY,
          alt: 'opacity-icon',
          onclick: this.handleTransparencyClicked,
          validationMethod: toolbarValidations.canAddTransparencyTool,
          id: Constants.TRANSPARENCY_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.transparency,
          highlight_path: Icons.transparency_selected,
          disabled_path: Icons.transparency_selected
        },
        {
          name: string.DUPLICATE_KEY,
          alt: 'clone-icon',
          onclick: dispatchers.fabricCanvasActions.cloneElement,
          validationMethod: toolbarValidations.canAddDuplicateTool,
          id: Constants.DUPLICATE_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.duplicate,
          highlight_path: Icons.duplicate_selected,
          disabled_path: Icons.duplicate_disabled
        },
        {
          name: string.ROTATE_KEY,
          alt: 'rotate-icon',
          onclick: this.handleRotateClicked,
          validationMethod: toolbarValidations.canAddRotateTool,
          id: Constants.ROTATE_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.rotate,
          highlight_path: Icons.rotate_selected,
          disabled_path: Icons.rotate_disabled
        },
        {
          name: string.ALIGN_KEY,
          alt: 'align-icon',
          onclick: this.handleAlignClicked,
          validationMethod: toolbarValidations.canAddAlignTool,
          id: Constants.ALIGN_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.align,
          highlight_path: Icons.align_selected,
          disabled_path: Icons.align_disabled
        },
        {
          name: string.RESIZE_ARBITRARILY_KEY,
          alt: 'resize-arbitrarily-icon',
          onclick: dispatchers.fabricCanvasActions.resizeArbitrarily,
          validationMethod: toolbarValidations.canAddResizeArbitrarilyTool,
          id: Constants.RESIZE_ARBITRARILY_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.resize_arbitrarily,
          highlight_path: Icons.resize_arbitrarily_selected,
          disabled_path: Icons.resize_arbitrarily_disabled
        },
        {
          name: string.RESIZE_PROPORTIONALLY_KEY,
          alt: 'resize-proportionally-icon',
          onclick: dispatchers.fabricCanvasActions.resizeProportionally,
          validationMethod: toolbarValidations.canAddResizeProportionallyTool,
          id: Constants.RESIZE_PROPORTIONALLY_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.resize_proportionally,
          highlight_path: Icons.resize_proportionally_selected,
          disabled_path: Icons.resize_proportionally_disabled
        },
        {
          name: string.SCALE_KEY,
          alt: 'scale-icon',
          onclick: this.handleScaleClicked,
          validationMethod: toolbarValidations.canAddScaleTool,
          id: Constants.SCALE_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.scale,
          highlight_path: Icons.scale_selected,
          disabled_path: Icons.scale_disabled
        },
        {
          name: string.ZOOM_IN_KEY,
          alt: 'zoom-in',
          id: Constants.ZOOM_IN_TOOL,
          onclick: dispatchers.canvasZoomActions.handleZoomIn,
          validationMethod: toolbarValidations.canAddZoomInTool,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.zoom_in,
          highlight_path: Icons.zoom_in_selected,
          disabled_path: Icons.zoom_in_disabled
        },
        {
          name: string.ZOOM_OUT_KEY,
          alt: 'zoom-out',
          id: Constants.ZOOM_OUT_TOOL,
          onclick: dispatchers.canvasZoomActions.handleZoomOut,
          validationMethod: toolbarValidations.canAddZoomOutTool,
          state: Constants.DISABLED_STATE,
          icon_path: Icons.zoom_out,
          highlight_path: Icons.zoom_out_selected,
          disabled_path: Icons.zoom_out_disabled
        },
        {
          name: string.SCALE_ALL_KEY,
          alt: 'scale-all-icon',
          onclick: this.handleScaleClicked,
          validationMethod: toolbarValidations.canAddScaleAllTool,
          id: Constants.SCALE_ALL_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.scaleAll,
          highlight_path: Icons.scaleAll_selected,
          disabled_path: Icons.scaleAll_disabled
        },
        {
          name: string.CLEAR_ALL_KEY,
          alt: 'clear-all-icon',
          onclick: this.handleClearAll,
          validationMethod: toolbarValidations.canAddClearAllTool,
          id: Constants.CLEAR_ALL_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.clearAll,
          highlight_path: Icons.clearAll_selected,
          disabled_path: Icons.clearAll_disabled
        },
        {
          name: string.LOCK_KEY,
          alt: 'lock-icon',
          onclick: this.handleLock,
          validationMethod: toolbarValidations.canAddLockTool,
          id: Constants.LOCK_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.lock,
          highlight_path: Icons.lock_selected,
          disabled_path: Icons.lock_disabled
        },
        {
          name: string.UNLOCK_KEY,
          alt: 'unlock-icon',
          onclick: this.handleLock,
          validationMethod: toolbarValidations.canAddUnlockTool,
          id: Constants.UNLOCK_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.unlock,
          highlight_path: Icons.unlock_selected,
          disabled_path: Icons.unlock_disabled
        },
        {
          name: string.SET_SIZE_KEY,
          alt: 'set-size-icon',
          onclick: this.handleSetSizeClicked,
          validationMethod: toolbarValidations.canAddSetSizeTool,
          id: Constants.SET_SIZE_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.scale,
          highlight_path: Icons.scale_selected,
          disabled_path: Icons.scale_disabled
        },
        {
          name: string.DELETE_KEY,
          alt: 'delete-icon',
          onclick: dispatchers.fabricCanvasActions.deleteElement,
          validationMethod: toolbarValidations.canAddDeleteTool,
          id: Constants.DELETE_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.delete,
          highlight_path: Icons.delete_selected,
          disabled_path: Icons.delete_disabled
        },
        {
          name: string.SEND_TO_BACK_KEY,
          alt: 'send-to-back-icon',
          onclick: dispatchers.fabricCanvasActions.sendToBack,
          validationMethod: toolbarValidations.canAddSendToBackTool,
          id: Constants.SEND_TO_BACK_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.sendToBack,
          highlight_path: Icons.sendToBack_selected,
          disabled_path: Icons.sendToBack_disabled
        },
        {
          name: string.BRING_TO_FRONT_KEY,
          alt: 'bring-to-front-icon',
          onclick: dispatchers.fabricCanvasActions.bringToFront,
          validationMethod: toolbarValidations.canAddBringToFrontTool,
          id: Constants.BRING_TO_FRONT_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.bringToFront,
          highlight_path: Icons.bringToFront_selected,
          disabled_path: Icons.bringToFront_disabled
        },
        {
          name: string.FLIP_KEY,
          alt: 'flipX-icon',
          onclick: dispatchers.fabricCanvasActions.flipXElement,
          validationMethod: toolbarValidations.canAddFlipTool,
          id: Constants.FLIP_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.flip,
          highlight_path: Icons.flip_selected,
          disabled_path: Icons.flip_disabled
        },
        {
          name: string.SCALE_TO_FILL_KEY,
          alt: 'scale-to-fill-icon',
          onclick: dispatchers.fabricCanvasActions.scaleToFill,
          validationMethod: toolbarValidations.canAddScaleToFillTool,
          id: Constants.SCALE_TO_FILL_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.scaleToFit,
          highlight_path: Icons.scaleToFit_selected,
          disabled_path: Icons.scaleToFit_disabled
        },
        {
          name: 'Stretch',
          alt: 'stretch-icon',
          onclick: dispatchers.multiWallHandler.stretchScene,
          validationMethod: toolbarValidations.canAddStretchTool,
          id: Constants.STRETCH_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.stretch,
          highlight_path: Icons.stretch_selected,
          disabled_path: Icons.stretch_disabled
        },
        {
          name: 'Unstretch',
          alt: 'unstretch-icon',
          onclick: dispatchers.multiWallHandler.unstretchScene,
          validationMethod: toolbarValidations.canAddUnstretchTool,
          id: Constants.UNSTRETCH_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.unstretch,
          highlight_path: Icons.unstretch_selected,
          disabled_path: Icons.unstretch_disabled
        },
        {
          name: string.GROUP_ALL_KEY,
          alt: 'group-all-icon',
          onclick: dispatchers.fabricCanvasActions.groupAll,
          validationMethod: toolbarValidations.canAddGroupTool,
          id: Constants.GROUP_ALL_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.group_all,
          highlight_path: Icons.group_all_selected,
          disabled_path: Icons.group_all_disabled
        },
        {
          name: string.UNGROUP_KEY,
          alt: 'ungroup-icon',
          onclick: dispatchers.fabricCanvasActions.Ungroup,
          validationMethod: toolbarValidations.canAddUngroupTool,
          id: Constants.UNGROUP_TOOL,
          state: Constants.NORMAL_STATE,
          icon_path: Icons.group_all,
          highlight_path: Icons.group_all_selected,
          disabled_path: Icons.group_all_disabled
        }
      ]
    });
  };

  updateToolState = item => {
    const { toolState } = this.state;

    if (
      item.id === Constants.GROUP_ALL_TOOL ||
      item.id === Constants.UNGROUP_TOOL ||
      item.id === Constants.UNLOCK_TOOL ||
      item.id === Constants.LOCK_TOOL
    ) {
      this.setState({ toolState: !toolState });
    }
  };

  toolbarItemClicked = item => {
    const { activeObject, undoInstance, dispatchers, wallCanvas } = this.props;
    const selectedObjects = [];
    if (activeObject.type === 'activeSelection') {
      activeObject.forEachObject(ele => {
        selectedObjects.push(ele);
      });
    } else {
      selectedObjects.push(activeObject);
    }
    undoInstance.beginGroup();
    selectedObjects.forEach(obj => {
      if (item.state !== Constants.DISABLED_STATE) {
        this.updateToolState(item);
        dispatchers.fabricCanvasActions.setSelectedTool(item);
        this.forceUpdate();

        if (!obj.lockMovementX || item.id === Constants.UNLOCK_TOOL) {
          item.onclick(obj, wallCanvas, item);
        }
      }
    });
    undoInstance.endGroup();
  };

  scaleIsClicked = value => {
    const { activeObject, dispatchers, wallCanvas, selectedTool } = this.props;

    const val = parseFloat(value).toFixed(2);
    switch (selectedTool.id) {
      case Constants.SCALE_TOOL:
        dispatchers.fabricCanvasActions.scaleCanvas(
          val,
          activeObject,
          wallCanvas
        );
        break;

      case Constants.SCALE_ALL_TOOL:
        dispatchers.fabricCanvasActions.groupScaleCanvas(
          val,
          activeObject,
          wallCanvas
        );
        break;

      default:
        break;
    }
  };

  handleTransparencyClose = () => {
    const { activeObject } = this.props;
    const { transparencyModalStatus } = this.state;
    this.setState({
      transparencyModalStatus: !transparencyModalStatus
    });

    this.handleTransparencyToSave(1 - activeObject.opacity);
  };

  handleTransparencyClicked = () => {
    const { activeObject, dispatchers } = this.props;
    const { transparencyModalStatus } = this.state;

    // handled to seperate calling of modal incase of undo
    dispatchers.fabricCanvasActions.beginTransparency(activeObject);
    this.setState({
      transparencyModalStatus: !transparencyModalStatus,
      initialValue: 1 - activeObject.opacity
    });

    this.toggleTransparencyModal();
  };

  handleTransparencyToSave = () => {
    const { activeObject, dispatchers } = this.props;
    dispatchers.fabricCanvasActions.endTransparency(activeObject);
  };

  toggleTransparencyModal = () => {
    const { activeObject, dispatchers } = this.props;

    dispatchers.fabricCanvasActions.dragTransparencyModal(activeObject, {
      x: 0,
      y: 0
    });
  };

  // Rotate actions
  handleRotateClose = () => {
    const { rotateModalStatus } = this.state;

    this.setState({
      rotateModalStatus: !rotateModalStatus
    });
  };

  handleRotateClicked = () => {
    const { activeObject } = this.props;
    const { rotateModalStatus } = this.state;

    // handled to seperate calling of modal incase of undo
    this.setState({
      rotateModalStatus: !rotateModalStatus,
      initialValue: activeObject.angle
    });
    this.toggleRotateModal();
  };

  toggleRotateModal = () => {
    const { activeObject, dispatchers, wallCanvas } = this.props;

    dispatchers.fabricCanvasActions.rotateElement(
      activeObject,
      activeObject.angle,
      wallCanvas
    );
    dispatchers.fabricCanvasActions.dragModal(null, {
      x: 0,
      y: 0
    });
  };

  toggleDragModal = () => {
    const { dispatchers } = this.props;
    const { rotateModalStatus } = this.state;

    this.setState({ rotateModalStatus: !rotateModalStatus });
    dispatchers.fabricCanvasActions.dragModal(null, {
      x: 0,
      y: 0
    });
  };

  // Scale actions
  toggleScaleModal = () => {
    const { activeObject, dispatchers } = this.props;
    dispatchers.fabricCanvasActions.dragScalarModal(activeObject, {
      x: 0,
      y: 0
    });
  };

  handleScaleClose = () => {
    const { activeObject } = this.props;
    const { scalarModalStatus } = this.state;

    if (isImageBasedBackground(activeObject)) {
      this.setState({
        scalarModalStatus: !scalarModalStatus
      });
    }

    this.handleScaleToSave(activeObject.scaleSliderValue);
  };

  handleScaleClicked = (activeObject, canvas, item) => {
    const { dispatchers } = this.props;
    const { scalarModalStatus } = this.state;
    let isGroupScaleTool = false;
    if (item.id === Constants.SCALE_ALL_TOOL) {
      isGroupScaleTool = true;
      this.setState({ isGroupScale: true });
    } else {
      this.setState({ isGroupScale: false });
    }

    dispatchers.fabricCanvasActions.beginScale(activeObject, isGroupScaleTool);

    // handled to seperate calling of modal incase of undo
    if (isImageBasedBackground(activeObject)) {
      this.setState({
        scalarModalStatus: !scalarModalStatus,
        initialValue: activeObject.scaleSliderValue
      });
    }
    this.toggleScaleModal(item);
  };

  handleScaleToSave = () => {
    const { activeObject, dispatchers, selectedTool } = this.props;

    // update final step instead of continuous values from scale drag.
    let isGroupScaleTool = false;
    if (selectedTool.id === Constants.SCALE_ALL_TOOL) {
      isGroupScaleTool = true;
    }

    dispatchers.fabricCanvasActions.endScale(activeObject, isGroupScaleTool);
  };

  handleLock = activeObject => {
    const { dispatchers } = this.props;
    if (activeObject.placing.locked) {
      dispatchers.fabricCanvasActions.unlockObject(activeObject);
    } else {
      dispatchers.fabricCanvasActions.lockObject(activeObject);
    }
  };

  onScrollUp = () => {
    document.getElementById('scrollHorizontal').scrollLeft -= 20;
  };

  onScrollDown = () => {
    document.getElementById('scrollHorizontal').scrollLeft += 20;
  };

  //  align
  handleAlignClicked = () => {
    const { alignPopoverStatus } = this.state;

    this.setState({
      alignPopoverStatus: !alignPopoverStatus
    });
  };

  resetAlignStatus = () => {
    this.setState({
      alignPopoverStatus: false
    });
  };

  onMouseMove = event => {
    const { originX } = this.state;

    let condition = false;
    if (event == 'tool-drag') {
      condition = true;
    }

    if (originX !== condition) {
      this.setState({ originX: condition });
    }
  };

  getRotateModalValue = e => {
    const { activeObject, dispatchers, wallCanvas } = this.props;
    dispatchers.fabricCanvasActions.handleInputRotateModal(
      e.target.value,
      activeObject,
      wallCanvas
    );
  };

  setScaleValue = (e, mode) => {
    let value = 0;
    if (mode === 'slider') {
      value = parseFloat(e.target.value).toFixed(2);
    } else if (mode === 'manual') {
      if (parseFloat(e.target.value) > 100) {
        value = 100;
      } else value = e.target.value;
    }
    this.setState(
      {
        initialValue: value
      },
      () => {
        const { initialValue } = this.state;
        this.scaleIsClicked(initialValue);
      }
    );
  };

  setTransparencyValue = (e, mode) => {
    const { activeObject, dispatchers, wallCanvas } = this.props;
    let value;
    if (mode === 'slider') {
      value = e.target.value;
    } else if (mode === 'manual') {
      if (parseFloat(e.target.value) > 1) {
        value = 1;
      } else if (parseFloat(e.target.value) < 0) {
        value = 0;
      } else {
        value = e.target.value;
      }
    }
    this.setState({
      initialValue: value
    });
    dispatchers.fabricCanvasActions.transparencyElement(
      value,
      activeObject,
      wallCanvas
    );
  };

  renderRotateTool = () => {
    const {
      activeObject,
      dispatchers,
      wallCanvas,
      rotateModalValue
    } = this.props;
    return (
      <RotateTool
        rotateModalValue={rotateModalValue}
        rotateRight={() =>
          dispatchers.fabricCanvasActions.rotateElement(
            activeObject,
            activeObject.angle + 90,
            wallCanvas
          )
        }
        rotateLeft={() =>
          dispatchers.fabricCanvasActions.rotateElement(
            activeObject,
            activeObject.angle - 90,
            wallCanvas
          )
        }
        getRotateModalValue={this.getRotateModalValue}
      />
    );
  };

  handleSetSizeClicked = () => {
    const { setSizeModalStatus } = this.state;
    this.setState({
      setSizeModalStatus: !setSizeModalStatus
    });
  };

  handleSetSizeClose = () => {
    const { setSizeModalStatus } = this.state;

    this.setState({
      setSizeModalStatus: !setSizeModalStatus
    });
  };

  renderSetSize = () => {
    const { unitSystem, activeObject, project, dispatchers } = this.props;
    const activeCanvas = dispatchers.getActiveCanvas(activeObject.placing);
    const wallHeight = project.activeWall ? project.activeWall.height : 0;
    const wallWidth = project.activeWall ? project.activeWall.width : 0;

    return (
      <SetSizeTool
        handleCancel={this.handleSetSizeClose}
        unitSystem={unitSystem}
        activeObject={activeObject}
        wallHeight={wallHeight}
        wallWidth={wallWidth}
        scale={wallHeight / activeCanvas.height}
      />
    );
  };

  renderScaleTool = () => {
    const { scalarModalValue } = this.props;
    const { initialValue } = this.state;

    return (
      <ScaleTool
        scalarModalValue={scalarModalValue}
        initialValue={initialValue}
        setScaleValue={this.setScaleValue}
      />
    );
  };

  renderTransparencyTool = () => {
    const { initialValue } = this.state;
    return (
      <TransparencyTool
        initialValue={initialValue}
        setTransparencyValue={this.setTransparencyValue}
      />
    );
  };

  render() {
    const {
      projectCategory,
      partnerStoreType,
      isGrouped,
      dispatchers,
      viewType,
      dimensions,
      draggableToolPosition,
      draggableModalPosition,
      wallCanvas,
      activeObject
    } = this.props;

    const {
      toolBarOptions,
      originX,
      initialValue,
      alignToolIndex,
      isAlignTooltipOpen,
      alignPopoverStatus,
      rotateModalStatus,
      scalarModalStatus,
      setSizeModalStatus,
      transparencyModalStatus,
      isGroupScale
    } = this.state;

    const alignToolOptions = [
      {
        alt: string.ALIGN_LEFT_KEY,
        icon_path: Icons.alignLeftDefault,
        highlight_path: Icons.alignLeftHover,
        id: Constants.ALIGN_TOOL_KEY.ALIGN_LEFT
      },
      {
        alt: string.ALIGN_CENTER_KEY,
        icon_path: Icons.alignCenterDefault,
        highlight_path: Icons.alignCenterHover,
        id: Constants.ALIGN_TOOL_KEY.ALIGN_CENTER
      },
      {
        alt: string.ALIGN_RIGHT_KEY,
        icon_path: Icons.alignRightDefault,
        highlight_path: Icons.alignRightHover,
        id: Constants.ALIGN_TOOL_KEY.ALIGN_RIGHT
      },
      {
        alt: string.ALIGN_TOP_KEY,
        icon_path: Icons.alignTopDefault,
        highlight_path: Icons.alignTopHover,
        id: Constants.ALIGN_TOOL_KEY.ALIGN_TOP
      },
      {
        alt: string.ALIGN_MIDDLE_KEY,
        icon_path: Icons.alignMiddleDefault,
        highlight_path: Icons.alignMiddleHover,
        id: Constants.ALIGN_TOOL_KEY.ALIGN_MIDDLE
      },
      {
        alt: string.ALIGN_BOTTOM_KEY,
        icon_path: Icons.alignBottomDefault,
        highlight_path: Icons.alignBottomHover,
        id: Constants.ALIGN_TOOL_KEY.ALIGN_BOTTOM
      }
    ];

    if (activeObject == null) {
      return null;
    }

    const isCanvas = dispatchers.homeActions.checkIfCanvasApp();
    const hasMultiwalls =
      dispatchers.multiWallHandler.hasLeftMultiWallProjects() ||
      dispatchers.multiWallHandler.hasRightMultiWallProjects();

    const filteredOptions = [];
    const isSharedScene = dispatchers.multiWallHandler.isSharedScene();
    const validationMethodsArguments = [
      viewType,
      isCanvas,
      activeObject,
      wallCanvas,
      projectCategory,
      partnerStoreType,
      hasMultiwalls,
      isSharedScene
    ];
    toolBarOptions.forEach(item => {
      if (item.validationMethod(...validationMethodsArguments)) {
        filteredOptions.push(item);
      }
    });
    filteredOptions.forEach(tool => {
      if (
        tool.id !== Constants.LOCK_TOOL &&
        tool.id !== Constants.UNLOCK_TOOL
      ) {
        if (activeObject.lockMovementX) {
          tool.state = Constants.DISABLED_STATE;
        } else if (
          isGrouped &&
          (tool.id === Constants.SCALE_TOOL || tool.id === Constants.FLIP_TOOL)
        ) {
          tool.state = Constants.DISABLED_STATE;
        } else if (tool.id === Constants.ZOOM_OUT_TOOL) {
          if (wallCanvas.getZoom() > 1) {
            tool.state = Constants.NORMAL_STATE;
          } else {
            tool.state = Constants.DISABLED_STATE;
          }
        } else {
          tool.state = Constants.NORMAL_STATE;
        }
      }
    });
    dispatchers.fabricCanvasActions.setFilteredTools(filteredOptions);
    const alignToolFiltered = filteredOptions.filter(
      option => option.id == Constants.ALIGN_TOOL
    );
    const isAlignToolPresent = alignToolFiltered.length > 0;

    const rootPlayground = document.getElementById('root-playground');
    const rootPlaygroundWidth = rootPlayground ? rootPlayground.clientWidth : 0;

    const toolbar = document.getElementById('outer-toolbar');
    const toolbarWidth = toolbar ? toolbar.clientWidth : 0;
    const showScroller =
      toolbarWidth > window.innerWidth ||
      toolbarWidth === window.innerWidth ||
      toolbarWidth > rootPlaygroundWidth ||
      toolbarWidth === rootPlaygroundWidth;
    const isSignageProduct = isSignageSuiteProduct();

    const defaultPosition =
      window.innerWidth <= 760 ? { x: 0, y: 0 } : { x: -350, y: 0 };

    return (
      <div
        id='toolbar'
        className={
          viewType === Constants.TWO_D_TYPE ? 'center-aligned-toolbar' : null
        }
        style={{
          bottom: '100px'
        }}
      >
        <Draggable
          position={draggableToolPosition}
          bounds={{
            left: -(dimensions.orgWindowWidth - toolbarWidth) / 2,
            bottom: isSignageProduct ? 50 : 0,
            top: -(dimensions.orgWindowHeight - Constants.HEADER_HEIGHT),
            right: (dimensions.orgWindowWidth - toolbarWidth) / 2
          }}
          cancel='.custom-input-box'
          onStart={dispatchers.fabricCanvasActions.dragToolbar}
          onStop={dispatchers.fabricCanvasActions.dragToolbar}
          disabled={!originX}
        >
          <div className='outer-layer-toolbar' id='outer-toolbar'>
            <div
              className='outer-layer-toolbar'
              onMouseMove={() => this.onMouseMove('')}
            >
              <div
                role='button'
                tabIndex='0'
                className={showScroller ? 'scroll-horizontal' : 'd-none'}
                onClick={this.onScrollUp}
                onKeyPress={() => {}}
              >
                <img src={Icons.prev_arrow_white} alt='down-arrow' />
              </div>
              <div
                id='scrollHorizontal'
                className={
                  showScroller
                    ? 'inner-tool-layer horizontal-scroller'
                    : 'inner-tool-layer'
                }
              >
                {filteredOptions.map(option => (
                  <ToolbarItem
                    key={option.alt}
                    item={option}
                    itemIsClicked={this.toolbarItemClicked}
                    alignToolIsOpen={alignPopoverStatus}
                    toolState={option.state}
                  />
                ))}
              </div>
              <div
                role='button'
                tabIndex='0'
                className={showScroller ? 'scroll-horizontal' : 'd-none'}
                onClick={this.onScrollDown}
                onKeyPress={() => {}}
              >
                <img src={Icons.next_arrow_white} alt='down-arrow' />
              </div>
            </div>
            <div
              className='toolbar-drag'
              onMouseMove={() => this.onMouseMove('tool-drag')}
            >
              <div className='d-flex justify-content-center align-items-center'>
                <img
                  alt='drag-icon'
                  src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAAABGdBTUEAALGPC/xhBQAAADtJREFUKBVjnDNnzlYGIEhJSfEG0SCAT4wJooThP5RGpogVQ9YzJNiM+EIEW8iNhhIsXvGF3Ggo0SSUANCaNiUctCaPAAAAAElFTkSuQmCC'
                />
                <div className='inner-overlay' />
              </div>
            </div>
          </div>
        </Draggable>
        {/* Roate Modal */}
        <DraggableModal
          isOpen={rotateModalStatus}
          title={string.ROTATE_KEY}
          body={this.renderRotateTool()}
          handleClose={this.handleRotateClose}
          modalPosition={draggableModalPosition}
          onDrag={dispatchers.fabricCanvasActions.dragModal}
        />
        {/* Scalar Modal */}
        <DraggableModal
          isOpen={scalarModalStatus}
          title={isGroupScale ? string.GROUP_SCALE : string.SCALE_KEY}
          body={this.renderScaleTool()}
          handleClose={this.handleScaleClose}
          modalPosition={draggableModalPosition}
          onDrag={dispatchers.fabricCanvasActions.dragModal}
        />
        {/* Transparency Modal */}
        <DraggableModal
          isOpen={transparencyModalStatus}
          title={string.TRANSPARENCY_KEY}
          body={this.renderTransparencyTool()}
          handleClose={this.handleTransparencyClose}
          initialValue={initialValue}
          modalPosition={draggableModalPosition}
          onDrag={dispatchers.fabricCanvasActions.dragModal}
        />
        {/* Set Size Modal */}
        <DraggableModal
          isOpen={setSizeModalStatus}
          body={this.renderSetSize()}
          handleClose={this.handleSetSizeClose}
          modalPosition={draggableModalPosition}
          defaultPosition={defaultPosition}
          onDrag={dispatchers.fabricCanvasActions.dragModal}
        />
        ;{/* Align tool  */}
        {toolbarValidations.canAddAlignTool(activeObject) &&
        isAlignToolPresent ? (
          <Popover
            id='align-tool'
            className='mb-4'
            placement='top'
            isOpen={alignPopoverStatus}
            target='toolbar-align-icon'
            toggle={this.handleAlignClicked}
          >
            {alignToolOptions.map((item, index) => (
              <div
                role='button'
                tabIndex='0'
                id={`element-${item.id}`}
                className='align-tool-container'
                onClick={() => {
                  dispatchers.fabricCanvasActions.alignElement(
                    item.id,
                    wallCanvas
                  );
                  this.hideOrShowAlignTooltip(false, index);
                }}
                onMouseLeave={() => {
                  this.hideOrShowAlignTooltip(false, index);
                }}
                onMouseEnter={() => {
                  this.hideOrShowAlignTooltip(true, index);
                }}
                onKeyPress={() => {}}
                key={item.id}
              >
                <img
                  className='icons'
                  src={
                    alignToolIndex === index && isAlignTooltipOpen
                      ? item.highlight_path
                      : item.icon_path
                  }
                  alt={item.alt}
                />
              </div>
            ))}
          </Popover>
        ) : null}
        {isAlignTooltipOpen ? (
          <Tooltip
            id='tooltip-inner'
            className='mb-3'
            isOpen={isAlignTooltipOpen}
            placement='top'
            target={`element-${alignToolOptions[alignToolIndex].id}`}
          >
            {alignToolOptions[alignToolIndex].alt}
          </Tooltip>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    wallCanvas: state.fabricCanvas.wallCanvas,
    activeObject: state.fabricCanvas.activeObject,
    rotateModalValue: state.fabricCanvas.rotateModalValue,
    scalarModalValue: state.fabricCanvas.scalarModalValue,
    transparencyModalValue: state.fabricCanvas.transparencyModalValue,
    draggableModalPosition: state.fabricCanvas.draggableModalPosition,
    project: state.finalCheck.project,
    selectedTool: state.fabricCanvas.selectedTool,
    language: state.home.language,
    isGrouped: state.fabricCanvas.isGrouped,
    renderFlag: state.fabricCanvas.renderFlag,
    undoInstance: state.fabricCanvas.undoInstance,
    projectCategory: state.modal.envData.category,
    partnerStoreType: state.modal.storeData.partnerStoreType,
    draggableToolPosition: state.fabricCanvas.draggableToolPosition,
    dimensions: state.fabricCanvas.dimensions,
    viewType: state.fabricCanvas.viewType,
    unitSystem: state.home.unitSystem
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      canvasZoomActions: bindActionCreators(canvasZoomActions, dispatch),
      homeActions: bindActionCreators(homeActions, dispatch),
      multiWallHandler: bindActionCreators(multiWallHandler, dispatch),
      getActiveCanvas: bindActionCreators(getActiveCanvas, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ToolBar);
